import React, { useEffect } from "react";
import "./Job_details.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import Vertical_Tracker from "../Common-Component/Vertical_Tracker/Vertical_Tracker";
import Standard_Delivery_card from "../Common-Component/Standard_Delivery_card/Standard_Delivery_card";
import Product_Specification_card from "../Common-Component/Product_Specification_card/Product_Specification_card";
import Order_Summary_gray_card from "../Common-Component/Order_Summary_gray_card/Order_Summary_gray_card";
import What_Expect_Next from "./What_Expect_Next/What_Expect_Next";
import Job_Address from "./Job_Address/Job_Address";
import Order_Tracker from "../Common-Component/Order_Tracker/Order_Tracker";
import Tracking_Details from "./Tracking_Details/Tracking_Details";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../features/order/orderSlice";
import { useParams } from "react-router-dom";
import { appSetup } from "../../features/master/masterSlice";
function Job_details() {

  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "ORDER", link: "/my-order" },
    { name: "JOB DETAILS" },
  ];
  // Define the step list
  const stepList = [
    { label: "Order Placed" },
    { label: "Design Review" },
    { label: "Production" },
    { label: "Dispatched" },
    { label: "Delivered" },
  ];
  const { id } = useParams();
  const order = useSelector((state) => state.order.order);
  const appsetup = useSelector((state) => state.master.app_setup);
  const dispatch = useDispatch();


  useEffect(() => {
    if (id) {
      dispatch(getOrder(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

 

  const getOrderProgress = (statusId) => {
    switch (statusId) {
      case 1:
        return 19;
      case 2:
        return 38;
      case 3:
        return 54;
      case 4:
        return 76;
      case 5:
        return 100;
      default:
        return 0;
    }
  };
  const progress = getOrderProgress(order?.order_status_id);  
  return (
    <>
      <section className="Job_details">
        <div className="custom_container">
          <div className="breadcrump_holder">
            <div className="Breadcrumb_div">
              <Breadcrumb_comp data={breadcrumbData} />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-4">
              <Vertical_Tracker order_status_id={order?.order_status_id} steps={stepList} percent={progress} />
            </div>

            <div className="col-lg-9 col-md-8">
              <Standard_Delivery_card order={order} />

              <Order_Tracker order={order} appsetup={appsetup}/>

              <Tracking_Details order={order} />

              <Product_Specification_card order={order} />

              <Order_Summary_gray_card order={order} />

              <What_Expect_Next order={order} />

              <Job_Address order={order} />


            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Job_details;
